module.exports = __webpack_public_path__ + "media/images/ready/icon-laptop-550fa0b60fea612212f97a60b25ea304.svg";